import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { MaterialReactTable } from 'material-react-table';
import Avatar from '@mui/material/Avatar';
import toast from 'react-hot-toast';
import LeadService from '../../core/services/leadsService';
import { LinearProgress } from '@mui/material';
import { Box, Button, Card } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon, SettingsSystemDaydreamSharp } from '@mui/icons-material';
import { useParams, useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Pagination from '@mui/material/Pagination';
import { debounce, throttle } from 'lodash';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import Papa from 'papaparse';


const useStyles = makeStyles((theme) => ({
    tableOverviewStyle: {
        [theme.breakpoints.down('lg')]: {
            width: '1320px',
        },
        [theme.breakpoints.up('macScreen')]: {
            width: '1400px',
        },
        [theme.breakpoints.down('md')]: {
            width: '1070px',
        },
        [theme.breakpoints.between('mlg', 'xl')]: {
            width: '1620px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1100px',
        },
    },
}));
const ReferralAgentDetails = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const { ref } = useParams();
    const location = useLocation();
    const { name, last_name } = location.state || {};
    const [GetAllAgents, setGetAllAgents] = React.useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const abortControllerRef = useRef(null);

    const getAgents = async (ref, currentPage) => {
        try {
            const res = await LeadService.getAgentsApiRefDetails(ref, currentPage);
            if (res?.data?.success) {
                setGetAllAgents(res?.data?.agents?.data);
                setCurrentPage(res?.data?.agents?.current_page);
                setTotalPages(Math.ceil(res?.data?.agents?.total / res?.data?.agents?.per_page));
                return;
            }
        } catch (error) {
            toast.error(error.message);
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const throttledAllReferralAgentDetails = useCallback(
        throttle((currentPage) => {
            getAgents(currentPage);
        }, 2000),
        []
    );

    const fetchAllAllReferralAgentDetails = useCallback(
        debounce((currentPage, searchTerm) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledAllReferralAgentDetails(currentPage, abortController.signal);
        }, 500),
        [throttledAllReferralAgentDetails]
    );
    useEffect(() => {
        fetchAllAllReferralAgentDetails(ref, currentPage);
    }, [ref, currentPage]);

    const adjustTimeBasedOnOffsetForReceivedDataPaymentsDate = (dateString, offsetInHours) => {
        const date = new Date(`${dateString}Z`);
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const truncateMessage = (text) => {
        if (text && text.length > 21) {
            return text.substring(0, 21) + '...';
        }
        return text;
    };

    const column = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 20,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'ahto',
                },
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },

        {
            accessorFn: (row) => {
                let fullName;
                if (row?.last_name === null) {
                    fullName = row?.name;
                } else {
                    fullName = `${row?.name} ${row?.last_name}`;
                }
                return truncateMessage(fullName);
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                align: 'left',
                sx: {
                    fontSize: 'auto',
                },
            },
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            // enableClickToCopy: true,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 150,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
        },
        // {
        //     accessorKey: 'location',
        //     header: 'Location',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 100,
        //     muiTableHeadCellProps: {
        //         sx: {
        //             fontSize: 'auto',
        //         },
        //     },
        // },
        // {
        //     accessorKey: 'refer_by',
        //     header: 'Refer Code',
        //     enableColumnActions: false,
        //     showColumnFilters: false,
        //     enableColumnFilter: false,
        //     enableSorting: false,
        //     size: 100,
        //     muiTableHeadCellProps: {
        //         sx: {
        //             fontSize: 'auto',
        //         },
        //     },
        // },
        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'subscription_type',
            header: 'Subscription Type',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const subscriptionType = row?.original?.subscription_type;
                const capitalFirstLetter = (type) => {
                    switch (type) {
                        case 'premier':
                            return 'Premier';
                        case 'elite':
                            return 'Elite';
                        case 'founder':
                            return 'Founder';
                        default:
                            return 'Unknown';
                    }
                };
                return <span>{capitalFirstLetter(subscriptionType ? subscriptionType : 'Not Subscribed')}</span>;
            },
        },
        {
            accessorKey: 'always_free',
            header: 'Paying',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ cell }) =>
                cell.getValue() === 0 ? <span>Subscribe to Any Plan</span> : <span style={{ fontWeight: 'bold' }}>Always Subscribed</span>,
        },
        {
            accessorKey: 'trial_start_at',
            header: 'Trail Start',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trial_start_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'trail_end_at',
            header: 'Trail End',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trail_end_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userLastPayment',
            header: 'Last Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userLastPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'userExpiryPayment',
            header: 'Expire Payment',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.userExpiryPayment;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'deleted_at',
            header: 'Deleted at',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.deleted_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'last_login',
            header: 'Last Login',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.last_login;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return 'Never Logged In';
            },
        },
        {
            accessorKey: 'app_version',
            header: 'App Version',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
    ];
    const HandleBackNavigate = () => {
        navigate('/referralAgent');
        return;
    };

    const handleExportCSV = () => {
        if (!GetAllAgents || GetAllAgents.length === 0) {
            toast.error('No data to export');
            return;
        }
        const csvData = GetAllAgents?.map((agent) => ({
            'Sr No': agent?.id,
            // 'Profile Image': `https://iconnctapp.com/${agent?.profile_image}`,
            'User Name': agent?.last_name ? `${agent.name} ${agent?.last_name}` : agent.name,
            'Email ID': agent?.email,
            'Phone Number': agent?.phone,
            'Member Since': agent?.created_at ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(agent?.created_at, getUserOffset())) : '',
            'Subscription Type': agent?.subscription_type ? capitalizeFirstLetter(agent?.subscription_type) : 'Unknown',
            Paying: agent?.always_free === 0 ? 'Subscribe to Any Plan' : 'Always Subscribed',
            'Trail Start': agent?.trial_start_at
                ? formatDateTime(adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(agent?.trial_start_at, getUserOffset()))
                : '',
            'Trail End': agent?.trail_end_at ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(agent?.trail_end_at, getUserOffset())) : '',
            'Last Payment': agent?.userLastPayment
                ? formatDateTime(adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(agent?.userLastPayment, getUserOffset()))
                : '',
            'Expire Payment': agent?.userExpiryPayment
                ? formatDateTime(adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(agent?.userExpiryPayment, getUserOffset()))
                : '',
            'Deleted At': agent?.deleted_at ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(agent?.deleted_at, getUserOffset())) : '',
            'Last Login': agent?.last_login
                ? formatDateTime(adjustTimeBasedOnOffsetForReceivedData(agent?.last_login, getUserOffset()))
                : 'Never Logged In',
            'App Version': agent?.app_version,
        }));
        // Convert the data to CSV
        const csv = Papa.unparse(csvData);
        const fileName = `${name || 'unknown'}_${last_name || 'unknown'}.csv`;
        // Create a download link and trigger it
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };
    // Utility function to capitalize the first letter of a string
    const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);
    return (
        <div>
            <Box>
                <Button
                    onClick={HandleBackNavigate}
                    sx={{ background: '#efefef', marginBottom: '10px', padding: '6px', '&:hover': { background: '#cecaca' } }}
                >
                    <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>
            </Box>
            <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Box>
                    <h1>
                        {name || ''} {last_name || ''}
                    </h1>
                </Box>
                <Box>
                    <Button variant="contained" color="primary" onClick={handleExportCSV} style={{ marginTop: '1rem' }}>
                        Export CSV
                    </Button>
                </Box>
            </Box>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px',
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1',
                            borderRadius: '10px',
                        },
                    }}
                />
                <div className={classes.tableOverviewStyle}>
                    <Card style={{ marginTop: '10px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <MaterialReactTable
                            columns={column}
                            data={GetAllAgents}
                            state={{ isLoading: isLoading }}
                            muiCircularProgressProps={{
                                color: 'secondary',
                                thickness: 5,
                                size: 55,
                            }}
                            muiSkeletonProps={{
                                animation: 'pulse',
                                height: 28,
                            }}
                            enableTopToolbar={false}
                            enableFacetedValues={true}
                            enableDensityToggle={false}
                            enableHiding={false}
                            showSkeletons={false}
                            enableStickyHeader={true}
                            enableColumnFilterModes={false}
                            enableColumnActions={false}
                            enableColumnOrdering={false}
                            enableFullScreenToggle={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            initialState={{
                                showColumnFilters: false,
                                showGlobalFilter: false,
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                    backgroundColor: '#f5f5f5', // Default row background color
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#ffffff', // Alternate rows with white
                                    },
                                    '&:hover': {
                                        backgroundColor: '#e0e0e0', // Hover effect
                                        cursor: 'pointer',
                                    },
                                },
                            }}
                        />
                    </Card>
                </div>
                <Box>
                    <Pagination
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                    />
                </Box>
            </ThemeProvider>
        </div>
    );
};
export default ReferralAgentDetails;
